import gql from 'graphql-tag'

export default gql`
  query course_projects_update($id: ID!) {
    courseProject(id: $id) {
      id
      description
      files {
        url
      }
      finishedUrl
      briefUrl
      image {
        id
        url
      }
      links {
        id
        url
      }
      slug
      title
    }
  }
`
